import React from "react";

const Svg = ({width = 15}: {width?: number} = {}) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1807_2687)">
        <path
          d="M15.001 7.50049C15.001 11.6428 11.6428 15.001 7.50049 15.001C3.35815 15.001 0 11.6428 0 7.50049C0 3.35815 3.35815 0 7.50049 0C11.6428 0 15.001 3.35815 15.001 7.50049ZM11.5611 10.1556C11.5052 10.0719 11.4023 9.95229 11.3206 9.90269L9.6779 8.90488C9.56292 8.9218 9.40407 8.9109 9.31347 8.95878L8.414 9.43762C8.31021 9.41124 8.12842 9.40464 8.04671 9.33755L7.42852 8.82947L6.16606 7.57418C6.01983 7.42881 5.90285 7.26566 5.78156 7.09449C5.71389 6.99901 5.68063 6.83242 5.65053 6.71486C5.62042 6.5973 5.66773 6.49752 5.72393 6.40749C5.9146 6.10155 6.28219 5.49484 6.14083 5.27664L4.9469 3.43356C4.58304 3.31858 4.22177 3.51499 3.93332 3.75469C3.64487 3.99439 3.42811 4.25302 3.40718 4.63265C3.38768 4.99077 3.42065 5.3595 3.54337 5.69956C3.68846 6.10126 3.86623 6.48146 4.07984 6.84991C4.38119 7.36946 5.14876 8.41486 5.53756 8.77385L6.93879 10.0678C7.39526 10.4893 7.90105 10.8139 8.44354 11.1147C8.80797 11.3168 9.1853 11.4559 9.58643 11.5789C10.1473 11.7506 10.8426 11.6924 11.1815 11.1766L11.5236 10.6559C11.6133 10.5194 11.6658 10.3127 11.5611 10.1553V10.1556Z"
          fill="#0077FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1807_2687">
          <rect width="15.001" height="15.001" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Svg;
